<template>
  <div class="air-segment mb-4 pb-4 has-text-grey-light">
    <div class="columns">
      <div class="column">
        <div class="columns is-mobile">
          <div class="column is-narrow">
            <div>
              <div></div>
              <div class="is-size-6 is-inline-block">
                {{ segment.startDate.date | formatDate }}
              </div>
              <div
                v-if="segment.startDate.date != segment.endDate.date"
                class="is-size-7 is-inline-block ml-4"
              >
                +{{ getDiff(segment.endDate.date, segment.startDate.date) }} day
              </div>
            </div>
            <h5 class="is-size-5 has-text-weight-light">
              {{ $helpers.getAirlineName(segment.airline) }}
            </h5>

            <div>
              <div class="is-size-7 has-text-grey">
                Flight Number:

                <span class="has-text-weight-bold has-text-grey"
                  >{{ segment.airline }}{{ segment.flightNumber }}</span
                >
              </div>
            </div>
            <div class="is-size-7 has-text-grey">
              Confirmation Number:
              <span class="has-text-weight-bold">{{
                segment.confirmationNumber
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="columns is-mobile mb-0">
          <div class="column">
            <div class="is-size-4 has-text-weight-bold has-text-grey">
              {{ segment.origin }}
            </div>
            <div class="is-size-7 has-text-weight-semibold has-text-grey">
              {{ $helpers.getAirportLocation(segment.origin) }}
            </div>
          </div>
          <div class="column">
            <div class="is-size-7 pt-3 has-text-centered">
              <b-icon
                icon="airplane"
                class="has-text-grey"
                custom-class="mdi-rotate-45"
              ></b-icon>
            </div>
          </div>
          <div class="column">
            <div class="is-size-4 has-text-weight-bold has-text-grey">
              {{ segment.destination }}
            </div>
            <div class="is-size-7 has-text-weight-semibold has-text-grey">
              {{ $helpers.getAirportLocation(segment.destination) }}
            </div>
          </div>
        </div>

        <div class="columns is-mobile">
          <div class="column pt-0">
            <div class="is-size-7 has-text-grey mt-1">
              Departs:
            </div>
            <div>
              <span class="is-size-6 has-text-weight-bold has-text-grey">
                {{ segment.startDate.time | formatTime }}
              </span>
            </div>
          </div>
          <div class="column"></div>
          <div class="column pt-0">
            <div class="is-size-7 has-text-grey mt-1 ">
              Arrives:
            </div>

            <div>
              <span class="is-size-6 has-text-weight-bold has-text-grey">
                {{ segment.endDate.time | formatTime }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="is-size-7">
      Cancelled by {{ segment.meta.cancelRequester.toLowerCase() }} on
      {{ segment.meta.cancelDate.date | formatDate }} @
      {{ segment.meta.cancelDate.time | formatTime }}
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "AirCancelled",
  components: {},
  props: {
    segment: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    getDiff(start, end) {
      return moment(start).diff(moment(end), "days");
    },
  },
};
</script>

<style>
.air-segment {
  border-bottom: 1px dashed #ddddde;
}
</style>
